interface QuickWinsProps {
  onSendPrompt: (prompt: string) => void;
  disabled?: boolean;
}

const QUICK_WINS = [
  { label: 'Wasted Spend', prompt: 'Find wasted spend and negative keyword opportunities in the last 30 days' },
  { label: 'Top Performers', prompt: 'Show me the top performing campaigns and ad groups by ROAS this month' },
  { label: 'Budget Gaps', prompt: 'Which campaigns are limited by budget and how much additional spend would they need?' },
  { label: 'Quality Score', prompt: 'Show keywords with low quality scores and suggest improvements' },
];

export default function QuickWins({ onSendPrompt, disabled }: QuickWinsProps) {
  return (
    <select
      className="command-bar-select"
      value=""
      onChange={(e) => {
        if (e.target.value) {
          onSendPrompt(e.target.value);
          e.target.value = '';
        }
      }}
      disabled={disabled}
      title="Quick analysis prompts"
    >
      <option value="">Quick Wins</option>
      {QUICK_WINS.map((qw) => (
        <option key={qw.label} value={qw.prompt}>{qw.label}</option>
      ))}
    </select>
  );
}
